import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-gradient-to-r from-[#0f172a] to-[#1e293b] shadow-lg border-b-2 border-[#e2b13c]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src="/images/logo-vtc-weppes.jpg" 
                alt="VTC des Weppes Logo" 
                className="h-16 w-auto object-contain"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-md text-sm font-semibold transition-all duration-200 ${
                isActive('/') 
                  ? 'bg-[#e2b13c] text-[#0f172a]' 
                  : 'text-white hover:bg-[#1e293b] hover:text-[#e2b13c]'
              }`}
            >
              Accueil
            </Link>
            <Link
              to="/qui-sommes-nous"
              className={`px-4 py-2 rounded-md text-sm font-semibold transition-all duration-200 ${
                isActive('/qui-sommes-nous') 
                  ? 'bg-[#e2b13c] text-[#0f172a]' 
                  : 'text-white hover:bg-[#1e293b] hover:text-[#e2b13c]'
              }`}
            >
              Qui sommes-nous ?
            </Link>
            <Link
              to="/gares-aeroports"
              className={`px-4 py-2 rounded-md text-sm font-semibold transition-all duration-200 ${
                isActive('/gares-aeroports') 
                  ? 'bg-[#e2b13c] text-[#0f172a]' 
                  : 'text-white hover:bg-[#1e293b] hover:text-[#e2b13c]'
              }`}
            >
              Gares & Aéroports
            </Link>
            <Link
              to="/transport-pmr"
              className={`px-4 py-2 rounded-md text-sm font-semibold transition-all duration-200 ${
                isActive('/transport-pmr') 
                  ? 'bg-[#e2b13c] text-[#0f172a]' 
                  : 'text-white hover:bg-[#1e293b] hover:text-[#e2b13c]'
              }`}
            >
              Transport PMR
            </Link>
            <Link
              to="/evenements"
              className={`px-4 py-2 rounded-md text-sm font-semibold transition-all duration-200 ${
                isActive('/evenements') 
                  ? 'bg-[#e2b13c] text-[#0f172a]' 
                  : 'text-white hover:bg-[#1e293b] hover:text-[#e2b13c]'
              }`}
            >
              Événements
            </Link>
            <Link
              to="/vehicules"
              className={`px-4 py-2 rounded-md text-sm font-semibold transition-all duration-200 ${
                isActive('/vehicules') 
                  ? 'bg-[#e2b13c] text-[#0f172a]' 
                  : 'text-white hover:bg-[#1e293b] hover:text-[#e2b13c]'
              }`}
            >
              Nos Véhicules
            </Link>
          </div>

          {/* Contact CTA */}
          <div className="hidden md:flex items-center space-x-3">
            <a href="tel:0695731320" className="px-4 py-2 bg-[#e2b13c] text-[#0f172a] rounded-md font-bold text-sm hover:bg-[#d4a434] transition-all duration-200 shadow-lg">
              📞 06 95 73 13 20
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-[#e2b13c] hover:text-white focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden bg-[#1e293b] border-t border-[#e2b13c]">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <Link to="/" className="block px-3 py-2 rounded-md text-white hover:bg-[#0f172a] hover:text-[#e2b13c] font-semibold" onClick={() => setIsOpen(false)}>Accueil</Link>
            <Link to="/qui-sommes-nous" className="block px-3 py-2 rounded-md text-white hover:bg-[#0f172a] hover:text-[#e2b13c] font-semibold" onClick={() => setIsOpen(false)}>Qui sommes-nous ?</Link>
            <Link to="/gares-aeroports" className="block px-3 py-2 rounded-md text-white hover:bg-[#0f172a] hover:text-[#e2b13c] font-semibold" onClick={() => setIsOpen(false)}>Gares & Aéroports</Link>
            <Link to="/transport-pmr" className="block px-3 py-2 rounded-md text-white hover:bg-[#0f172a] hover:text-[#e2b13c] font-semibold" onClick={() => setIsOpen(false)}>Transport PMR</Link>
            <Link to="/evenements" className="block px-3 py-2 rounded-md text-white hover:bg-[#0f172a] hover:text-[#e2b13c] font-semibold" onClick={() => setIsOpen(false)}>Événements</Link>
            <Link to="/vehicules" className="block px-3 py-2 rounded-md text-white hover:bg-[#0f172a] hover:text-[#e2b13c] font-semibold" onClick={() => setIsOpen(false)}>Nos Véhicules</Link>
            <a href="tel:0695731320" className="block px-3 py-2 rounded-md bg-[#e2b13c] text-[#0f172a] font-bold text-center mt-2">📞 06 95 73 13 20</a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;